import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useAuthenticationTokenCookie } from "src/authentication/hooks/useAuthenticationTokenCookie";
import type {
  AuthenticationCredentials,
  AuthenticationResult,
  AuthenticationResultSuccess,
} from "src/authentication/objects/Authentication";
import { AUTHENTICATION_API_PATH } from "src/confs/APIConfig";
import { useApiPost } from "src/shared/actions/FetchActions";

export const usePostAuthenticate = () => {
  const queryClient = useQueryClient();
  const { set: setAuthenticationTokenCookie } = useAuthenticationTokenCookie();
  return useCallback(
    async (authenticationResult: AuthenticationResultSuccess) => {
      setAuthenticationTokenCookie(JSON.stringify(authenticationResult));
      await queryClient.invalidateQueries("authenticationToken");
    },
    [queryClient, setAuthenticationTokenCookie],
  );
};

export const useAuthenticate = () => {
  const apiPost = useApiPost();
  const postAuthenticate = usePostAuthenticate();
  return useMutation(
    async (credentials: AuthenticationCredentials) => {
      return apiPost<AuthenticationResult>(
        `${AUTHENTICATION_API_PATH}/`,
        credentials,
      );
    },
    {
      onSuccess: async ({ data: authenticationResult }) => {
        if (!authenticationResult.isOtp) {
          await postAuthenticate(
            authenticationResult as AuthenticationResultSuccess,
          );
        }
      },
    },
  );
};
